const paymentAddress = {
  addTitle: 'Neue Rechnungsadresse hinzufügen',
  addSubtitle: 'Hier können Sie Ihre Rechnungsadresse hinzufügen.',
  editTitle: 'Rechnungsadresse bearbeiten',
  editSubtitle: 'Hier können Sie Ihre Rechnungsadresse bearbeiten.',
  save: 'Speichern',
  update: 'Aktualisieren',
  back: 'Zurück',
  newSuccess: 'Ihre neue Rechnungsadresse wurde erfolgreich hinzugefügt',
  editSuccess: 'Ihre Rechnungsadresse wurde erfolgreich geändert',
  fillNecessary: '* Bitte füllen Sie die Pflichtfelder aus',
}

export default paymentAddress
